import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    ADMIN,
    APPROVED,
    HOSPITAL,
    INDIVIDUAL,
    NURSE,
    WAITING,
} from '@constants/constants';
import {
    adminCreateUser,
    adminUpdateUser,
    deleteS3Object,
    updateUser,
} from '@utils/utils';
import { IoMdArrowRoundBack } from 'react-icons/io';
import { useParams, Link } from 'react-router-dom';
import { IoEyeOffOutline, IoEyeOutline } from 'react-icons/io5';
import SharpeInfoIcon from '@components/SvgComponents/SharpInfoIcon';
import { useAppSelector } from '@store/hooks';
import { useAppDispatch } from '@store/hooks';
import {
    setEmail,
    setMobileNumber,
    setName,
    setPassword,
    setUserRole,
} from '@store/reducers/auth/signupSlice';
import { useTranslation } from 'react-i18next';
import HospitalForm from './Form/HospitalForm';
import NurseForm from './Form/NurseForm';
import IndividualForm from './Form/IndividualForm';
import {
    PutItemCommand,
    DynamoDBClient,
    GetItemCommand,
    ScanCommand,
} from '@aws-sdk/client-dynamodb';
import { v4 as uuidv4 } from 'uuid';

import ErrorMessage from '@components/Error/ErrorMessage';

import awsConfig from '../amplifyconfiguration.json';
import { ConsoleLogger } from 'aws-amplify/utils';
import { FaArrowLeftLong } from 'react-icons/fa6';
import SuccessPopUp from './SuccessPopUpComponent';
import UserRole from '../views/pages/auth/UserRole';
import {
    COGNITO_USER_ID,
    TENANT_ID,
    USER_EMAIL,
    USER_MOBILE_NUMBER,
    USER_ROLE,
} from '@constants/cognitoAttributes';
import { hospitalInfoData, hospitalUserInfo } from '@utils/hospitalUtils';
import { getDataUsingHospitalId, getDataUsingUserId } from '@utils/sharedUtils';
import { HOSPITALS_TABLE, USER_INFO_TABLE } from '@constants/dynamoDBTableName';
import {
    EMAIL_MAX_Length,
    EMAIL_PATTERN,
    EMAIL_TITLE,
    MOBILE_NUMBER_MAX_LENGTH,
    MOBILE_NUMBER_MIN_LENGTH,
    MOBILE_NUMBER_PATTERN,
    MOBILE_NUMBER_TITLE,
    NAME_TEXT_MAX_LENGTH,
    NAME_TEXT_MIN_LENGTH,
    NAME_TEXT_PATTERN,
    NAME_TEXT_TITLE,
} from '@constants/form';
import Swal from 'sweetalert2';
const MySwal = Swal;
import { generateUniqueTimestamp } from '@utils/sharedUtils';
import { useAuditLog } from '../contexts/AuditLogContext';

interface UserDeviceList {
    id: number;
    device_id: string;
    create_date: string;
}

const UpdateAdminUserComponent: React.FC = () => {
    // const [name, setName] = useState('');
    // const [email, setEmail] = useState('');
    // const [mobileNo, setMobileNo] = useState('');
    // const [password, setPassword] = useState('');
    const [errors, setErrors] = useState<{ [key: string]: string }>({});
    const [error, setError] = useState<string | null>(null);
    const [hospitalDetails, setHopsitalDetails] = useState<any>({});
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const dispatch = useAppDispatch();
    const name = useAppSelector((state) => state.signup.name);
    const email = useAppSelector((state) => state.signup.email);
    const mobileNumber = useAppSelector((state) => state.signup.mobileNumber);
    const password = useAppSelector((state) => state.signup.password);
    const [buttonText, setButtonText] = useState('');
    const deviceUniqueID = useAppSelector(
        (state) => state.signup.deviceUniqueID
    );
    const userEmail = useAppSelector((state) => state.signup.email);
    const UserMobileNumber = useAppSelector(
        (state) => state.signup.mobileNumber
    );
    const userPassword = useAppSelector((state) => state.signup.password);
    const userDeviceUniqueID = useAppSelector(
        (state) => state.signup.deviceUniqueID
    );
    const userRole = useAppSelector((state) => state.signup.userRole);
    const userState = useAppSelector((state) => state.signup.userState);
    const userName = useAppSelector((state) => state.signup.name);
    const userTableID = useAppSelector((state) => state.signup.userTableID);
    const hospitalName = useAppSelector((state) => state.signup.hospital_name);
    const hospitalBranchName = useAppSelector(
        (state) => state.signup.hospital_branch
    );
    const adminHospitalName = useAppSelector((state) => state.signup.name);
    const hospitalWebsite = useAppSelector(
        (state) => state.signup.hospital_website
    );
    const hospitalEmailID = useAppSelector((state) => state.signup.email_id);
    const hospitalContactNumber = useAppSelector(
        (state) => state.signup.contact_no
    );
    const hospitalGST = useAppSelector((state) => state.signup.gst_no);
    const logo = useAppSelector((state) => state.signup.logo);
    const logo_name = useAppSelector((state) => state.signup.logo_name);
    const logo_url = useAppSelector((state) => state.signup.logo_url);
    const logo_type = useAppSelector((state) => state.signup.logo_type);
    const userAddressOne = useAppSelector((state) => state.signup.address_one);
    const userAddressTwo = useAppSelector((state) => state.signup.address_two);
    const userCity = useAppSelector((state) => state.signup.city);
    const userCountry = useAppSelector((state) => state.signup.country);
    const userPincode = useAppSelector((state) => state.signup.pincode);
    const { t } = useTranslation();
    const tenantUuid = uuidv4();
    const hospitalTenantUuid = uuidv4();
    const hospitalUuid = uuidv4();
    const hospitalInfoUuid = uuidv4();
    const userInfoUuid = uuidv4();
    const [userID, setUserID] = useState('');
    const [slugName, setSlugName] = useState('');
    const [showModal, setShowModal] = useState(false);
    const loggedInUserRole = useAppSelector(
        (state) => state.login.loggedInUserRole
    );
    const formattedDateTime = generateUniqueTimestamp();
    const loggedInUserTenantID = useAppSelector(
        (state) => state.login.loggedInUserTenantID
    );
    const loggedInUserID = useAppSelector(
        (state) => state.login.loggedInUserID
    );
    const { addLog } = useAuditLog();

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        try {
            const userAttributes = [
                {
                    Name: 'custom:mobile_number',
                    Value: mobileNumber,
                },
                {
                    Name: 'custom:name',
                    Value: userName,
                },
            ];
            await adminUpdateUser(email, userAttributes);
            let attributeNames: { [key: string]: string } = {
                '#name': 'name',
                '#mobile_number': 'mobile_number',
                '#modified_by': 'modified_by',
                '#modified_at': 'modified_at',
            };
            let attributeValues: { [key: string]: { S: string } } = {
                ':name': { S: userName },
                ':mobile_number': { S: mobileNumber },
                ':modified_by': { S: loggedInUserTenantID },
                ':modified_at': { S: formattedDateTime },
            };
            let updateExpression =
                'SET #name = :name,#mobile_number = :mobile_number, #modified_by = :modified_by, #modified_at = :modified_at';
            await updateUser(
                USER_INFO_TABLE,
                userTableID,
                attributeNames,
                attributeValues,
                updateExpression
            );
            addLog(
                'User Updated',
                userTableID,
                'User',
                loggedInUserID,
                { 'Name': userName, 'mobile_number': mobileNumber },
                window.location.hostname
            );
            dispatch(setMobileNumber(mobileNumber));
            dispatch(setName(userName));
            navigate(-1);
            MySwal.fire({
                position: 'top-end', // Position the toast in the top-right corner
                icon: 'success',
                title: 'admin user data updated successfully',
                showConfirmButton: false,
                timer: 1500,
                toast: true,
                customClass: {
                    popup: 'text-green bg-light_green', // Add custom class to the popup
                },
            });
        } catch (error: any) {
            let errorMessage;
            switch (error.name) {
                case 'UserNotFoundException':
                    errorMessage = 'User not found.';
                    break;
                case 'UsernameExistsException':
                    errorMessage = 'Email already exists.';
                    break;
                case 'InvalidParameterException':
                    errorMessage = 'Invalid parameters provided.';
                    break;
                case 'LimitExceededException':
                    errorMessage = 'Limit exceeded.';
                    break;
                case 'InternalErrorException':
                    errorMessage = 'Internal server error.';
                    break;
                default:
                    errorMessage =
                        error.message || 'An unknown error occurred.';
            }
            setError(errorMessage);
        }
    };

    const backArrow = () => {
        // console.log(pathname);
        // Check if the pathname matches any of the paths from AppConfig
        // if (pathname.startsWith(HOSPITAL_USER_PATH + '/')) {
        //     navigate(HOSPITAL_USER_PATH);
        // } else if (pathname.startsWith(INDIVIDUAL_USER_PATH + '/')) {
        //     navigate(INDIVIDUAL_USER_PATH);
        // } else if (pathname.startsWith(NURSE_PATH + '/')) {
        //     navigate(NURSE_PATH);
        // }
        navigate(-1);
    };

    const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        // dispatch(setName(event.target.value));
        const value = event.target.value;
        const regex = /^[A-Za-z\s]*$/;
        if (regex.test(value)) {
            dispatch(setName(value));
        }
    };

    const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        dispatch(setEmail(event.target.value));
    };

    const handleMobileNumberChange = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        const value = event.target.value;
        // Allow only numbers (0-9)
        if (/^\d*$/.test(value)) {
            dispatch(setMobileNumber(value));
        }
        // dispatch(setMobileNumber(event.target.value));
    };

    const handlePasswordChange = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        dispatch(setPassword(event.target.value));
    };

    const handleTogglePasswordVisibility = () => {
        setShowPassword((prevShowPassword) => !prevShowPassword);
    };

    return (
        <>
            <div className="mx-auto px-5">
                <div className="font-bold text-black text-base">
                    {/* <Link to={HOSPITAL_USER_PATH}> */}
                    <div
                        className="flex items-center cursor-pointer"
                        onClick={backArrow}
                    >
                        <FaArrowLeftLong className="" />{' '}
                        <h2 className="font-semibold ml-2">{buttonText}</h2>
                    </div>
                    {/* </Link> */}
                </div>
                {error && <ErrorMessage message={error} />}
                <div className="cart relative mx-auto bg-white rounded-2xl p-5 mt-5 w-11/12">
                    <form onSubmit={handleSubmit} className="w-10/12 mx-auto">
                        <div className="flex justify-start mt-3">
                            <div className="w-2/4 mr-8">
                                <label
                                    htmlFor="admin_name"
                                    className="mb-2 text-sm font-medium text-light_grey"
                                >
                                    {t('auth.signup.admin_name_lable')}
                                    <span className="text-red ml-2">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="admin_name"
                                    id="admin_name"
                                    value={name}
                                    onChange={handleNameChange}
                                    className="form-control px-3 py-2 placeholder-gains_boro"
                                    placeholder={t(
                                        'auth.signup.admin_name_placeholder'
                                    )}
                                    minLength={NAME_TEXT_MIN_LENGTH}
                                    maxLength={NAME_TEXT_MAX_LENGTH}
                                    title={NAME_TEXT_TITLE}
                                    pattern={NAME_TEXT_PATTERN}
                                    required
                                />
                            </div>
                            <div className="w-2/4">
                                <label
                                    htmlFor="mobile_number"
                                    className="mb-2 text-sm font-medium text-light_grey"
                                >
                                    {t('auth.signup.mobile_number_label')}
                                    <span className="text-red ml-2">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="mobile_number"
                                    id="mobile_number"
                                    value={mobileNumber}
                                    onChange={handleMobileNumberChange}
                                    className="form-control px-3 py-2 placeholder-gains_boro"
                                    placeholder={t(
                                        'auth.signup.mobile_number_placeholder'
                                    )}
                                    pattern={MOBILE_NUMBER_PATTERN}
                                    title={MOBILE_NUMBER_TITLE}
                                    minLength={MOBILE_NUMBER_MIN_LENGTH}
                                    maxLength={MOBILE_NUMBER_MAX_LENGTH}
                                    required
                                />
                            </div>
                        </div>
                        <div className="flex justify-start mt-4">
                            <div className="w-2/4 mr-8">
                                <label
                                    htmlFor="email"
                                    className="mb-2 text-sm font-medium text-light_grey"
                                >
                                    {t('auth.signup.email_id_label')}
                                    <span className="text-red ml-2">*</span>
                                </label>
                                <input
                                    type="email"
                                    name="email"
                                    id="signup_email"
                                    value={email}
                                    onChange={handleEmailChange}
                                    className="form-control px-3 py-2 placeholder-gains_boro"
                                    placeholder={t(
                                        'auth.signup.email_id_placeholder'
                                    )}
                                    pattern={EMAIL_PATTERN}
                                    title={EMAIL_TITLE}
                                    maxLength={EMAIL_MAX_Length}
                                    required
                                    autoComplete="off"
                                    disabled
                                />
                            </div>
                            {/* <div className="w-2/4">
                                <label
                                    htmlFor="password"
                                    className="mb-2 text-sm font-medium text-light_grey"
                                >
                                    {t('auth.signup.password_label')}
                                </label>
                                <div className="relative flex items-center rounded-md">
                                    <input
                                        type={
                                            showPassword ? 'text' : 'password'
                                        }
                                        name="password"
                                        id="signup_password"
                                        value={password}
                                        onChange={handlePasswordChange}
                                        className="form-control px-3 py-2 placeholder-gains_boro"
                                        placeholder={t(
                                            'auth.signup.password_placeholder'
                                        )}
                                        minLength={PASSWORD_MIN_Length}
                                        maxLength={PASSWORD_MAX_Length}
                                        pattern={PASSWORD_PATTERN}
                                        title={PASSWORD_TITLE}
                                        autoComplete="new-password"
                                    />
                                    <button
                                        type="button"
                                        className="absolute right-3 cursor-pointer"
                                        onClick={handleTogglePasswordVisibility}
                                    >
                                        {showPassword ? (
                                            <IoEyeOutline className="text-secondary" />
                                        ) : (
                                            <IoEyeOffOutline className="text-secondary" />
                                        )}
                                    </button>
                                </div>
                            </div> */}
                        </div>

                        <div className="  col-span-2 pb-14 absolute flex -bottom-40 left-1/2 -translate-x-2/4 cursor-pointer justify-center w-full">
                            <button
                                className="bg-primary text-lg text-white py-2  px-4 rounded-lg w-2/6"
                                type="submit"
                            >
                                {t('submit')}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default UpdateAdminUserComponent;
